import { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../../api/API_SERVERS";
import Loading from "../../otherComponents/Loading";
import AdForm from "./AdForm";
import AdTable from "./AdTable";
import { IoReceiptOutline, IoCloudUploadOutline, IoLayersOutline } from "react-icons/io5";
import "../../../design/AdsManager.css";

export default function AdsManager() {
    const [ads, setAds] = useState({ big: [], medium: [], small: [] });
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("big");
    const [statusFilter, setStatusFilter] = useState("all");

    // ოპერაციების დაყოფა: "publish" (განთავსება) ან "manage" (მართვა)
    const [activeOperation, setActiveOperation] = useState("publish");

    // Level 3 Takeover კალკულატორი
    const [takeoverCalc, setTakeoverCalc] = useState(null);
    const [calculating, setCalculating] = useState(false);
    const [showCalculator, setShowCalculator] = useState(false);

    const fetchAds = async () => {
        try {
            const res = await axios.get(API_URL + "/api/admin/ads", {
                headers: { Authorization: `Bearer ${localStorage.getItem("AdminToken")}` }
            });
            setAds(res.data);
        } catch (err) { console.error(err); }
    };

    useEffect(() => { fetchAds(); }, []);

    const handleDeactivate = async (id) => {
        if(!window.confirm("Deactivate this advertisement?")) return;
        setLoading(true);
        try {
            await axios.put(`${API_URL}/api/admin/ads/${id}`, {}, {
                headers: { Authorization: `Bearer ${localStorage.getItem("AdminToken")}` }
            });
            await fetchAds();
            if (showCalculator) calculateTakeover();
        } catch (err) {
            alert("Deactivate failed");
        } finally { setLoading(false); }
    };

    const calculateTakeover = async () => {
        setCalculating(true);
        try {
            const res = await axios.get(`${API_URL}/api/admin/ads/calculate-takeover`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("AdminToken")}` }
            });
            setTakeoverCalc(res.data);
        } catch (err) {
            console.error(err);
            alert("Failed to calculate takeover cost");
        } finally { setCalculating(false); }
    };

    const toggleCalculator = () => {
        const nextState = !showCalculator;
        setShowCalculator(nextState);
        if (nextState) { calculateTakeover(); }
    };

    const currentSizeAds = ads[activeTab] || [];
    const countAll = currentSizeAds.length;
    const countActive = currentSizeAds.filter(ad => ad.is_active === true).length;
    const countInactive = currentSizeAds.filter(ad => ad.is_active === false).length;

    const getFilteredAds = () => {
        if (statusFilter === "active") return currentSizeAds.filter(ad => ad.is_active === true);
        if (statusFilter === "inactive") return currentSizeAds.filter(ad => ad.is_active === false);
        return currentSizeAds;
    };

    return (
        <div className="am-container">
            {loading && <Loading />}

            {/* მთავარი ოპერაციების მართვის მენიუ (MAIN NAVIGATION TABS) */}
            <div className="am-revolver-pill" style={{ marginBottom: "2rem", width: "100%", maxWidth: "500px", background: "#f1f5f9", padding: "4px", borderRadius: "12px" }}>
                <button
                    className={`am-revolver-item ${activeOperation === 'publish' ? 'active' : ''}`}
                    onClick={() => setActiveOperation('publish')}
                    style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", padding: "10px" }}
                >
                    <IoCloudUploadOutline size={18} />
                    Publish New Banner
                </button>
                <button
                    className={`am-revolver-item ${activeOperation === 'manage' ? 'active' : ''}`}
                    onClick={() => setActiveOperation('manage')}
                    style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", padding: "10px" }}
                >
                    <IoLayersOutline size={18} />
                    Manage Active Banners
                </button>
            </div>

            {/* სექცია 1: ახალი რეკლამის განთავსება */}
            {activeOperation === "publish" && (
                <AdForm fetchAds={fetchAds} loading={loading} setLoading={setLoading} />
            )}

            {/* სექცია 2: არსებული რეკლემების მართვა და დათვალიერება */}
            {activeOperation === "manage" && (
                <>
                    {/* MONOPOLY CALCULATOR WIDGET */}
                    <div style={{ marginBottom: "1.5rem" }}>
                        <button
                            className="ui-page-btn"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                background: showCalculator ? "var(--danger)" : "var(--primary)",
                                color: "#fff",
                                padding: "10px 16px",
                                borderRadius: "8px",
                                border: "none",
                                cursor: "pointer",
                                fontWeight: "600"
                            }}
                            onClick={toggleCalculator}
                        >
                            <IoReceiptOutline size={18} />
                            {showCalculator ? "Hide Takeover Calculator" : "Calculate Level 3 Takeover Cost"}
                        </button>

                        {showCalculator && (
                            <div style={{
                                marginTop: "1rem",
                                background: "#f8fafc",
                                border: "1px dashed var(--primary)",
                                borderRadius: "16px",
                                padding: "1.5rem"
                            }}>
                                <h4 style={{ margin: "0 0 1rem 0", color: "var(--text-main)" }}>⚡ Active Monopoly & Refund Estimates</h4>
                                {calculating ? (
                                    <p style={{ fontStyle: "italic", color: "var(--text-muted)" }}>Analyzing active campaigns...</p>
                                ) : takeoverCalc ? (
                                    <div>
                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "1rem", marginBottom: "1.5rem" }}>
                                            <div style={{ background: "#fff", padding: "12px", borderRadius: "8px", border: "1px solid var(--border)" }}>
                                                <div style={{ fontSize: "0.75rem", fontWeight: "800", color: "var(--text-muted)" }}>BASE TAKEOVER FEE</div>
                                                <div style={{ fontSize: "1.4rem", fontWeight: "700" }}>₾{takeoverCalc.baseTakeoverFee.toFixed(2)}</div>
                                            </div>
                                            <div style={{ background: "#fff", padding: "12px", borderRadius: "8px", border: "1px solid var(--border)" }}>
                                                <div style={{ fontSize: "0.75rem", fontWeight: "800", color: "var(--danger)" }}>REQUIRED REFUNDS</div>
                                                <div style={{ fontSize: "1.4rem", fontWeight: "700", color: "var(--danger)" }}>₾{takeoverCalc.totalRefundRequired.toFixed(2)}</div>
                                            </div>
                                            <div style={{ background: "var(--primary)", padding: "12px", borderRadius: "8px", color: "#fff" }}>
                                                <div style={{ fontSize: "0.75rem", fontWeight: "800", opacity: 0.9 }}>TOTAL QUOTE FOR CLIENT</div>
                                                <div style={{ fontSize: "1.6rem", fontWeight: "800" }}>₾{takeoverCalc.finalTakeoverQuote.toFixed(2)}</div>
                                            </div>
                                        </div>

                                        {takeoverCalc.affectedCampaigns.length > 0 ? (
                                            <div>
                                                <h5 style={{ margin: "0 0 0.5rem 0" }}>Active Campaigns Affected ({takeoverCalc.affectedCampaigns.length}):</h5>
                                                <div style={{ maxHeight: "150px", overflowY: "auto", background: "#fff", borderRadius: "8px", border: "1px solid var(--border)", padding: "10px" }}>
                                                    <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: "0.85rem" }}>
                                                        {takeoverCalc.affectedCampaigns.map((camp, idx) => (
                                                            <li key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: idx !== takeoverCalc.affectedCampaigns.length - 1 ? "1px solid #f1f5f9" : "none" }}>
                                                                <span><strong>{camp.title}</strong> ({camp.owner}) — {camp.remainingDays} days left</span>
                                                                <span style={{ color: "var(--danger)", fontWeight: "700" }}>Refund: ₾{camp.totalAdRefund.toFixed(2)}</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        ) : (
                                            <p style={{ color: "#2e7d32", fontWeight: "600", margin: 0, fontSize: "0.85rem" }}>🎉 No other active advertisements. No refunds required!</p>
                                        )}
                                    </div>
                                ) : null}
                            </div>
                        )}
                    </div>

                    <div className="am-segmented-wrapper">
                        {/* 1. Size Revolver Controls */}
                        <div className="am-revolver-pill">
                            <button className={`am-revolver-item ${activeTab === 'big' ? 'active' : ''}`} onClick={() => setActiveTab('big')}>
                                Big Banners <span className="am-pill-badge">{ads.big?.length || 0}</span>
                            </button>
                            <button className={`am-revolver-item ${activeTab === 'medium' ? 'active' : ''}`} onClick={() => setActiveTab('medium')}>
                                Medium Banners <span className="am-pill-badge">{ads.medium?.length || 0}</span>
                            </button>
                            <button className={`am-revolver-item ${activeTab === 'small' ? 'active' : ''}`} onClick={() => setActiveTab('small')}>
                                Small Banners <span className="am-pill-badge">{ads.small?.length || 0}</span>
                            </button>
                        </div>

                        {/* 2. Status Metric Revolver Controls */}
                        <div className="am-revolver-pill">
                            <button className={`am-revolver-item ${statusFilter === 'all' ? 'active' : ''}`} onClick={() => setStatusFilter('all')}>
                                All Ads <span className="am-pill-badge">{countAll}</span>
                            </button>
                            <button className={`am-revolver-item filter-active ${statusFilter === 'active' ? 'active' : ''}`} onClick={() => setStatusFilter('active')}>
                                Active <span className="am-pill-badge">{countActive}</span>
                            </button>
                            <button className={`am-revolver-item filter-inactive ${statusFilter === 'inactive' ? 'active' : ''}`} onClick={() => setStatusFilter('inactive')}>
                                Deactivated <span className="am-pill-badge">{countInactive}</span>
                            </button>
                        </div>
                    </div>

                    <AdTable
                        ads={getFilteredAds()}
                        size={activeTab}
                        onDelete={handleDeactivate}
                        loading={loading}
                    />
                </>
            )}
        </div>
    );
}